import React, { useState, useEffect } from "react";
import { useRef } from "react";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import Header from "../../component/Header/Header";
import Footer from "../../component/Footer/Footer";
import EditTextField from "../../component/EditTextfieldComponent/index";
import Sidebar from "../Sidebar/index";
import "./editcatelogue.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { VehicleCategoryAction } from "../../actions/partcatelogueAction";
import { createcatalogueAction } from "../../actions/partcatelogueAction";
import { NotificationManager } from "react-notifications";
import { getVehiclelist_categoryAction } from "../../actions/getVehicle";
import Loader from "../../component/loaderComponent/Loader";
import DOMPurify from 'dompurify';
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { fileType } from "../../constants/filetype/filetype";
import { Modal } from "react-bootstrap";
import PopupConfirmation from "../../component/PopupConfirmation/PopupConfirmation";


function AddCatelogue() {
  const [statedata, setStateData] = useState({
    vehicle_name: "",
    vehicle_category: "",
    catalogue_image: "",
    catalogue_file: [],
  });
  const [confirmationPopupShow, setConfirmationPopupshow] = useState(false);
  const handleConfirmationPopup = () => {
    setConfirmationPopupshow(true);
  };
  const handleAddCateloguePopupCloseButtons = () => {
    if(
      selectedImage === null ||
      statedata?.vehicle_name === "" ||
      statedata?.vehicle_category === "" ||
      catalogue_file === null 
    ){
      navigate("/partcatelogue")
    }
    else{
      setConfirmationPopupshow(true);
    }
  };
  const closePartCatalogConfirmationPopup = () => {
    setConfirmationPopupshow(false);
  };
  const [vehicleList, setVehicleList] = useState([]);
  const [isLoadings, setIsLoadings] = useState(false);
  const [getVehiclecatList, setGetVehiclecatList] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const item = "Add";
  const { i18n, t } = useTranslation();
  const language = Cookies.get("language");

  const EditCatelogue = () => {
    navigate("/partcatelogue");
  };

  useEffect(() => {
    VehicleCategoryListData();
    handleChangeLanguage(language);
    if (statedata.vehicle_category) {
      CategoryVehicleListData(statedata?.vehicle_category);
    }
  }, [statedata.vehicle_category]);

  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  const [selectedImage, setSelectedImage] = useState(null);
  const [catalogue_file, setcatalogue_file] = useState(null);

  const fileInputRef = useRef(null);
  const fileInputRefs = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedImageTypes = fileType.IMAGE;
      if (allowedImageTypes.includes(file.type)) {
        setSelectedImage(file);
      } else {
        NotificationManager.error(t('validationmsg.invalidimage'))
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
      }
    }
  };
  
  const handleDeleteImage = () => {
    setSelectedImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };
  const handleFileUploads = (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedPdfTypes = fileType.PDF.mimeType;
      if (allowedPdfTypes.includes(file.type)) {
        setcatalogue_file(file);
      } else {
        NotificationManager.error(t('validationmsg.invalidpdf'))
        if (fileInputRefs.current) {
          fileInputRefs.current.value = null;
        }
      }
    }
  };

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    setStateData({
      ...statedata,
      [name]: value.replace(/^ +/gm, ""),
    });
  };
  async function VehicleCategoryListData() {
    setIsLoadings(true);
    let response = await dispatch(VehicleCategoryAction());
    if (response == 200 || response != null) {
      setIsLoadings(false);
      setVehicleList(response.data.data.results);
    } else if (response === undefined) {
      setIsLoadings(false);
    }
  }
  async function CategoryVehicleListData(id) {
    setIsLoadings(true);
    let response = await dispatch(getVehiclelist_categoryAction(id));
    if (response == 200 || response != null) {
      setIsLoadings(false);
      setGetVehiclecatList(response.data.data.results);
    }
  }

  const oncreatecatlogue = async () => {
    setIsLoadings(true);
    let apiReq = {
      vehicle: statedata.vehicle_name,
      catalogue_image: selectedImage,
      catalogue_file: catalogue_file,
    };
    let response = await dispatch(createcatalogueAction(apiReq));
    if (response == 200 || response != null) {
      setIsLoadings(false);
      NotificationManager.success(response.data.message);
      navigate("/partcatelogue");
      window.scroll(0, 0);
    } else if (response === undefined) {
      setIsLoadings(false);
    }
  };

  return (
    <div className="editcatelogue_containers">
      <div className="editcatelogue_container">
        <div className="editcateloguemain">
        <div className="header_border tvsparts_text">TVS &gt; {t('partcatalogues.addcatalogue')}</div>
          <div className="editcateloguebuttons_container">
            <span className="Addnew_text">{t('addcatalogues.addnewpartcatalogue')} </span>
            <button
              className="edit_catelogue_addbuttons"
              onClick={handleAddCateloguePopupCloseButtons}
            >
              {t('addparts.close')}
            </button>
          </div>
          {isLoadings ? (
            <Loader />
          ) : (
            <>
              <div className="editcatelogue_second_para">
                {selectedImage ? (
                  <img
                    src={DOMPurify.sanitize(URL.createObjectURL(selectedImage))}
                    alt="Uploaded"
                    className="product-img"
                  />
                ) : (
                  <img src={Image_Url.DUMMYCATALOGUE} />
                )}
                <label
                  className="select-lable-img required"
                  htmlFor="banner3"
                  onChange={handleImageChange}
                >
                  {t('addcatalogues.selectimage')}
                  <input
                    type="file"
                    name="banner3"
                    id="banner3"
                    hidden
                    ref={fileInputRef}
                    onChange={handleImageChange}
                    accept="image/*"
                  />
                </label>
              </div>
              <div className="editcatelogue_third_para">
                <EditTextField
                  vehicleList={vehicleList}
                  mode={item}
                  statedata={statedata}
                  handleChange={handleChange}
                  getVehiclecatList={getVehiclecatList}
                  handleFileUploads={handleFileUploads}
                  catalogue_file={catalogue_file}
                  fileInputRefs={fileInputRefs}
                />
              </div>
              <div className="third_para">
                <button
                  className="edit_catelogue_addbuttons"
                  onClick={handleConfirmationPopup}
                  disabled={
                    selectedImage ===null ||
                    statedata?.vehicle_name === "" ||
                    statedata?.vehicle_category === "" ||
                    catalogue_file ===null 
                  }
                >
                  {t('addcatalogues.upload')}
                </button>
              </div>
            </>
          )}
          <div className="footer_div">
            <Footer />
          </div>
        </div>
      </div>
      <Modal
        className="expertise-modal"
        show={confirmationPopupShow}
        onHide={closePartCatalogConfirmationPopup}
      >
        <Modal.Body>
          {confirmationPopupShow && (
            <PopupConfirmation
              handleConfirmationPopupClose={closePartCatalogConfirmationPopup}
              onSaveClick={oncreatecatlogue}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default AddCatelogue;
